import { createContext } from 'react';

export interface Company {
  id?: string;
  should_redirect_to_portal?: boolean;
}

export interface CompanyContextType {
  company: Company | null;
}

export const CompanyContext = createContext<CompanyContextType>({
  company: null,
});
